import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../styles.js'
import { getHideables } from '#components/generics/js/childHideable/container.js'
import { scope } from '#components/generics/js/selectors/scope.js'

const displayAction = (key, node) => {
  const actions = all(`[data-scope-json]`, node)

  for (const action of actions) {
    const { child_hideable_name } = scope(action)
    const { child_hideable_name: actionBarChildHideableName } = scope(key)

    if (child_hideable_name && child_hideable_name === actionBarChildHideableName) {
      closest(`.${elements.dropdown_item}`, action)
        ?.classList.toggle(utilities.modifiers.display.none, !key.classList.contains(utilities.modifiers.display.none))
    }
  }
}

export default (node, template = null) => {
  const opener = template?.parentNode

  if (opener) {
    const container = closest(`[data-contract~='childHideable.container']`, opener)

    if (container) {
      const { hideableScopeJsons } = getHideables(container)

      if (hideableScopeJsons) {
        for (const [key,] of hideableScopeJsons.entries()) {
          displayAction(key, node)
        }
      }
    }
  }
}
